export const MAIN_CLASS_NAME = 'content-split-view';
export const PLAINTEXT_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__plaintext`;
